import Grade from '../grade';
import {
  Box,
  Flex,
  Popover,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Text,
  Tooltip,
} from '@chakra-ui/react';
import { t } from 'i18next';
import { useState } from 'react';
import { useGetIsLeaderSuitFlag } from '@lon/shared/hooks';
import { SsStandardsAggregationTypeEnum } from '@lon/shared/requests';

export default function CellWithPopover({
  item,
  info,
  grade,
  aggregateBy,
  children,
}: {
  item: {
    standard: string;
    description?: string;
  };
  info: any;
  grade: number | undefined;
  aggregateBy: SsStandardsAggregationTypeEnum;
  children: React.ReactNode;
}) {
  const [showDesc, setShowDesc] = useState(false);
  const isLeaderSuit = useGetIsLeaderSuitFlag();

  if (
    !isLeaderSuit ||
    aggregateBy !== SsStandardsAggregationTypeEnum.Student ||
    !item.description
  ) {
    return (
      <Tooltip variant="dark" label={item.standard} aria-hidden={true}>
        <Flex justify="center">
          <Grade grade={grade} />
        </Flex>
      </Tooltip>
    );
  }

  return (
    <Popover
      isOpen={showDesc}
      onClose={() => setShowDesc(false)}
      placement="auto"
      closeOnBlur
    >
      <PopoverTrigger>
        <Tooltip
          variant="dark"
          label={t('reportsDashboard.showDetails') as string}
          aria-hidden={true}
          isDisabled={showDesc}
        >
          <Box
            onClick={(e) => {
              e.stopPropagation();
              setShowDesc(true);
            }}
            cursor="pointer"
            position="relative"
          >
            {children}
          </Box>
        </Tooltip>
      </PopoverTrigger>
      <PopoverContent bg="white" color="primary.800" padding={6}>
        <PopoverBody p={0}>
          <Flex gap={4} flexDirection="column">
            <Flex justify="space-between" alignItems="center">
              <Text variant="h6" color="primary.800">
                {item.standard}
              </Text>
              <PopoverCloseButton
                type="button"
                color="primary.800"
                position="relative"
                pb="14px"
              />
            </Flex>
            <Text variant="s2" color="primary.800" whiteSpace="pre-wrap">
              {
                t('reportsDashboard.studentGradeDetails', {
                  studentName: info.row.original.studentName,
                  grade: grade,
                }) as string
              }
            </Text>
          </Flex>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
